import React from "react";
import { Modal, Button, withStyles } from "@material-ui/core";
import CloseIcon from "@material-ui/icons/Close";
import Typography from "@material-ui/core/Typography";

export const ModalAlerta = (props) => {
  const {
    aoFechar,
    classes,
    descricao,
    titulo,
    exibeBotaoFechar = true,
    ...rest
  } = props;

  return (
    <div className={classes.boxModal} {...rest}>
      <Modal
        className={classes.modal}
        aria-labelledby="modal-title"
        aria-describedby="modal-description"
        open={true}
      >
        <div className={classes.modalContainer}>
          <div id="containerModalLote" className={classes.modalConteudo}>
            {exibeBotaoFechar && (
              <Button
                className={classes.fechar}
                id="botao-fechar-modal"
                onClick={aoFechar}
              >
                <CloseIcon />
              </Button>
            )}

            {titulo != null && (
              <Typography
                className={classes.titulo}
                id="modal-title"
                variant="h6"
              >
                {titulo}
              </Typography>
            )}

            <Typography
              className={classes.descricao}
              component="div"
              id="modal-description"
              variant="body1"
            >
              {descricao}
            </Typography>

            <Button
              className={classes.sair}
              id="botao-sair-modal"
              onClick={aoFechar}
              variant="text"
            >
              Sair
            </Button>
          </div>
        </div>
      </Modal>
    </div>
  );
};

const styles = (theme) => {
  return {
    modal: {
      zIndex: "0",
    },
    modalContainer: {
      display: "flex",
      height: "100%",
      width: "100%",
    },
    modalConteudo: {
      display: "flex",
      position: "relative",
      flexDirection: "column",
      gap: "20px",
      margin: "auto",
      width: "auto",
      maxWidth: "min(60%,980px)",
      height: "auto",
      backgroundColor: "#ffffff",
      outline: "none",
      boxShadow: "0 2px 20px 0 rgba(0, 0, 0, 0.5)",
      borderRadius: "18px",
      padding: "40px",
    },
    titulo: {
      fontWeight: "700",
    },
    descricao: {
      marginBottom: "20px",
      "& > *:not(:last-child)": {
        marginBottom: "16px",
      },
      "& > *": {
        margin: 0,
      },
    },
    fechar: {
      minWidth: "auto",
      position: "absolute",
      top: "0px",
      right: "0px",
    },
    sair: {
      alignSelf: "center",
      color: theme.palette.primary.main,
      fontWeight: "700",
      padding: 0,
    },
  };
};

export default withStyles(styles)(ModalAlerta);
